/**
 * Globally loading icon show and hide
 * Example - $Loading.show(); $Loading.hide();
 * this function can call from anywhere in vue pages
 */
const loading = {};

loading.show = () => {
    VueApp.$store.commit('loading');
}

loading.hide = () => {
    VueApp.$store.commit('hideLoading');
}

export default loading;
